import { useCallback, useEffect } from 'react';

import config from '../../config';
import { initLocale } from '../../i18n';
import { useGetLanguageFromCurrentPage } from '../../utils/use-get-language-from-current-page';

import { LanguageLoaderProps } from './language-loader.config';

const LanguageLoader = ({ children }: LanguageLoaderProps) => {
  const language = useGetLanguageFromCurrentPage();

  const init = useCallback(() => {
    initLocale(language || config.FALLBACK_LANGUAGE);
  }, [language]);

  useEffect(() => {
    init();
  }, [init]);

  return <>{children}</>;
};

export default LanguageLoader;
